/*
  CUSTOM CHANGE — neue Datei (komplett custom)
  Youmee.market — Quick Cart (Seitenfenster)
  Datei: assets/ym-quick-cart.js   Erstellt: 2026-10-15
  Menge/Entfernen ueber die offizielle Shopify Cart-API (/cart/change.js).
  Danach wird der Inhalt ueber Ellas eigene Funktion neu geladen (window.sharedFunctions.updateSidebarCart),
  damit Oeffnen/Schliessen, Zaehler im Header usw. weiterhin von Ella kommen.
  Aenderung 2026-10-15 (#47): "Passt dazu" – Zusatzprodukt per /cart/add.js hinzufuegen.
  Aenderung 2026-10-16 (#50): "Passt dazu" aufklappbar; bleibt offen, solange das Fenster offen ist.
*/
(() => {
  if (window.ymQuickCartLoaded) return;
  window.ymQuickCartLoaded = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const timers = new Map();
  let upOpen = false;

  function applyUpsell() {
    const box = document.querySelector('[data-ym-qc] .ym-qc__upsell');
    const btn = document.querySelector('[data-ym-qc-more]');
    if (box) box.classList.toggle('is-open', upOpen);
    if (btn) btn.setAttribute('aria-expanded', upOpen ? 'true' : 'false');
  }

  // Nach jedem Neuladen des Quick-Cart-Inhalts den Auf/Zu-Zustand wieder setzen
  const watchWrapper = () => {
    const target = wrapper();
    if (!target || target.dataset.ymWatch === 'true' || !('MutationObserver' in window)) return;
    target.dataset.ymWatch = 'true';
    new MutationObserver(() => {
      const box = target.querySelector('.ym-qc__upsell');
      if (box && box.classList.contains('is-open') !== upOpen) applyUpsell();
    }).observe(target, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchWrapper); else watchWrapper();

  function wrapper() {
    return document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  }

  async function refresh(cart) {
    const shared = window.sharedFunctions;
    if (shared && typeof shared.updateSidebarCart === 'function') {
      shared.updateSidebarCart(cart);
      return;
    }
    // Fallback ohne Ella-Funktion
    try {
      const html = await (await fetch(`${ROOT}cart?view=ajax_side_cart`, { cache: 'no-store' })).text();
      const target = wrapper();
      if (target) target.innerHTML = html;
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (e) {
      window.location.reload();
    }
  }

  function showError(text) {
    const qc = document.querySelector('[data-ym-qc]');
    if (!qc) return;
    let box = qc.querySelector('.ym-qc__alert');
    if (!box) {
      box = document.createElement('p');
      box.className = 'ym-qc__alert';
      box.setAttribute('role', 'alert');
      qc.prepend(box);
    }
    box.textContent = text;
  }

  async function change(key, quantity) {
    const qc = document.querySelector('[data-ym-qc]');
    if (qc) qc.classList.add('is-busy');
    try {
      const res = await fetch(`${ROOT}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await res.json();
      if (!res.ok) {
        showError(data.description || data.message || 'Das hat leider nicht geklappt.');
        const cart = await (await fetch(`${ROOT}cart.js`)).json();
        setTimeout(() => refresh(cart), 1500);
        return;
      }
      await refresh(data);
    } catch (e) {
      showError('Das hat leider nicht geklappt. Bitte versuche es nochmals.');
      if (qc) qc.classList.remove('is-busy');
    }
  }

  async function add(btn) {
    const qc = document.querySelector('[data-ym-qc]');
    const id = parseInt(btn.dataset.ymQcAdd, 10);
    if (!id) return;
    btn.classList.add('is-adding');
    if (qc) qc.classList.add('is-busy');
    try {
      const res = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        showError(data.description || data.message || 'Das hat leider nicht geklappt.');
        btn.classList.remove('is-adding');
        if (qc) qc.classList.remove('is-busy');
        return;
      }
      const cart = await (await fetch(`${ROOT}cart.js`, { cache: 'no-store' })).json();
      await refresh(cart);
    } catch (e) {
      showError('Das hat leider nicht geklappt. Bitte versuche es nochmals.');
      btn.classList.remove('is-adding');
      if (qc) qc.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const qc = event.target.closest('[data-ym-qc]');
    if (!qc) return;
    watchWrapper();

    const moreBtn = event.target.closest('[data-ym-qc-more]');
    if (moreBtn) { event.preventDefault(); upOpen = !upOpen; applyUpsell(); return; }

    const addBtn = event.target.closest('[data-ym-qc-add]');
    if (addBtn) { event.preventDefault(); add(addBtn); return; }

    const step = event.target.closest('[data-ym-qc-step]');
    if (step) {
      event.preventDefault();
      const item = step.closest('[data-ym-qc-item]');
      const val = item.querySelector('.ym-qc__qty-val');
      const next = Math.max(0, (parseInt(val.textContent, 10) || 0) + parseInt(step.dataset.ymQcStep, 10));
      val.textContent = next;                                  // sofort anzeigen
      if (next === 0) item.classList.add('is-removing');
      const key = item.dataset.key;
      clearTimeout(timers.get(key));
      timers.set(key, setTimeout(() => change(key, next), 350));
      return;
    }

    const remove = event.target.closest('[data-ym-qc-remove]');
    if (remove) {
      event.preventDefault();
      const item = remove.closest('[data-ym-qc-item]');
      item.classList.add('is-removing');
      change(item.dataset.key, 0);
    }
  });
})();
